import { render, staticRenderFns } from "./NoAdmin.vue?vue&type=template&id=7ff384b4&"
import script from "./NoAdmin.vue?vue&type=script&lang=js&"
export * from "./NoAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports